export default "__VITE_ASSET__OuWTX4Ox4l3mL6WWT6fbrQ__"